export const PERMISSION_READ_ASSETS: Permission = 'read assets'
export const PERMISSION_WRITE_ASSETS: Permission = 'write assets'
export const PERMISSION_READ_PORTFOLIOS: Permission = 'read portfolios'
export const PERMISSION_WRITE_PORTFOLIOS: Permission = 'write portfolios'
export const PERMISSION_READ_COMPANY_DATA: Permission = 'read company data'
export const PERMISSION_WRITE_COMPANY_DATA: Permission = 'write company data'
export const PERMISSION_READ_COMPANY_USERS: Permission = 'read company users'
export const PERMISSION_WRITE_COMPANY_USERS: Permission = 'write company users'
export const PERMISSION_READ_COMPANIES: Permission = 'read companies'
export const PERMISSION_WRITE_COMPANIES: Permission = 'write companies'
export const PERMISSION_READ_USERS: Permission = 'read users'
export const PERMISSION_WRITE_USERS: Permission = 'write users'
export const PERMISSION_READ_UNPUBLISHED_ARTICLES: Permission = 'read unpublished articles'
export const PERMISSION_VIEW_ADMIN_PANEL: Permission = 'view admin panel'

export type Permission =
  | 'read assets'
  | 'write assets'
  | 'read portfolios'
  | 'write portfolios'
  | 'read company data'
  | 'write company data'
  | 'read company users'
  | 'write company users'
  | 'read companies'
  | 'write companies'
  | 'read users'
  | 'write users'
  | 'read unpublished articles'
  | 'view admin panel'
